import React from "react";
import { InputText, InputTextProps } from "primereact/inputtext";

interface Props extends InputTextProps {
  keyName?: string;
  name: string;
  value?: string;
  label: string;
  onChange: (event: any) => void;
  inputClassName?: string;
  maxLength?: number;
}

export const FloatingLabelInput = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <span className="p-float-label w-100">
      <InputText
        ref={ref}
        key={props.keyName}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        className="w-100"
        maxLength={props.maxLength}
      />
      <label htmlFor="inputtext">{props.label}</label>
    </span>
  );
});

export const FloatingLabelInputWithUpdatableStyle = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <span className="p-float-label w-100">
      <InputText
        ref={ref}
        key={props.keyName}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        className={props.inputClassName}
        style={{ width: "100%" }}
        maxLength={props.maxLength}
      />
      <label htmlFor="inputtext">{props.label}</label>
    </span>
  );
});
